import { ROLES } from '@AuthModule';

const {
  ADOPTER,
  ADOPTIONS_REPORT,
  ALL_ANIMALS_TABLE,
  DONOR,
  DRIVER,
  FOSTER,
  INTAKES_REPORT,
  INTAKES_SOURCE_REPORT,
  MEDICAL_REPORTS,
  OUTCOMES_REPORT,
  OWNER,
  PEOPLE,
  RTO_REPORT,
  VIEW_BEHAVIOR,
  VOLUNTEER,
} = ROLES;

// NOTE :: Every list with saved reports turned on (its FiltersTemplate `savedReportsTableId`, also the api's
// SavedReportController::SAVED_REPORT_LISTS): the label the Shared Reports page shows and the route "View filter"
// opens, and the permissions its route needs, if any — any one of them is enough, like the route guard (the api's
// SavedReportController::LIST_PERMISSIONS mirrors it). A list added to the api must be added here too.
const SAVED_REPORT_LISTS: Record<string, { label: string; permissions?: ROLES[]; routeName: string }> = {
  'all-animals': { label: 'navigation.animals.all', permissions: [ALL_ANIMALS_TABLE], routeName: 'all-animals' },
  'animals-in-care': { label: 'navigation.animals.inCare', routeName: 'animals-in-care' },
  people: {
    label: 'navigation.people',
    permissions: [PEOPLE, ADOPTER, OWNER, FOSTER, DONOR, VOLUNTEER, DRIVER],
    routeName: 'people',
  },
  'reports-adoption': {
    label: 'navigation.reports.outcomes.adoptions',
    permissions: [ADOPTIONS_REPORT],
    routeName: 'reports-adoption',
  },
  'reports-clinic-in': {
    label: 'navigation.reports.intakes.clinicIn',
    permissions: [INTAKES_REPORT],
    routeName: 'reports-clinic-in',
  },
  'reports-clinic-out': {
    label: 'navigation.reports.outcomes.clinicOut',
    permissions: [OUTCOMES_REPORT],
    routeName: 'reports-clinic-out',
  },
  'reports-intakes': {
    label: 'navigation.reports.intakes.report',
    permissions: [INTAKES_REPORT],
    routeName: 'reports-intakes',
  },
  'reports-intakes-source': {
    label: 'navigation.reports.intakes.source',
    permissions: [INTAKES_SOURCE_REPORT],
    routeName: 'reports-intakes-source',
  },
  'reports-medical-behavior': {
    label: 'navigation.reports.medical.behavior',
    permissions: [VIEW_BEHAVIOR],
    routeName: 'reports-medical-behavior',
  },
  'reports-medical-daily-diagnostics': {
    label: 'navigation.reports.medical.dailyDiagnostics',
    permissions: [MEDICAL_REPORTS],
    routeName: 'reports-medical-daily-diagnostics',
  },
  'reports-medical-daily-medications': {
    label: 'navigation.reports.medical.dailyMedications',
    permissions: [MEDICAL_REPORTS],
    routeName: 'reports-medical-daily-medications',
  },
  'reports-medical-daily-procedures': {
    label: 'navigation.reports.medical.dailyProcedures',
    permissions: [MEDICAL_REPORTS],
    routeName: 'reports-medical-daily-procedures',
  },
  'reports-medical-daily-surgeries': {
    label: 'navigation.reports.medical.dailySurgeries',
    permissions: [MEDICAL_REPORTS],
    routeName: 'reports-medical-daily-surgeries',
  },
  'reports-medical-daily-vaccinations': {
    label: 'navigation.reports.medical.dailyVaccinations',
    permissions: [MEDICAL_REPORTS],
    routeName: 'reports-medical-daily-vaccinations',
  },
  'reports-medical-rabies': {
    label: 'navigation.reports.medical.rabies',
    permissions: [MEDICAL_REPORTS],
    routeName: 'reports-medical-rabies',
  },
  'reports-outcomes': {
    label: 'navigation.reports.outcomes.report',
    permissions: [OUTCOMES_REPORT],
    routeName: 'reports-outcomes',
  },
  'reports-rto': {
    label: 'navigation.reports.outcomes.rto',
    permissions: [RTO_REPORT],
    routeName: 'reports-rto',
  },
  'reports-service-in': {
    label: 'navigation.reports.intakes.serviceIn',
    permissions: [INTAKES_REPORT],
    routeName: 'reports-service-in',
  },
  'reports-service-out': {
    label: 'navigation.reports.outcomes.serviceOut',
    permissions: [OUTCOMES_REPORT],
    routeName: 'reports-service-out',
  },
};

// NOTE :: The query param "View filter" on the Shared Reports page adds to a list's route; the list reads it, applies
// that shared report as an unsaved view and drops the param.
const REPORT_TEMPLATE_QUERY = 'shared_report';

export { REPORT_TEMPLATE_QUERY, SAVED_REPORT_LISTS };
